import React, { useState } from 'react';
import './ChatbotConfig.css';

const ChatbotConfig = () => {
  const [config, setConfig] = useState({
    botName: 'Figbot',
    greeting: 'Hello! How can I help you today?',
    tone: 'friendly',
    allowedTopics: ''
  });

  const handleChange = (e) => {
    setConfig({
      ...config,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = () => {
    // TODO: Save to API
    alert('Configuration saved successfully!');
  };

  return (
    <div className="chatbot-config-page">
      <h2>Chatbot Configuration</h2>
      <div className="config-card">
        <div className="form-group">
          <label>Bot Name</label>
          <input
            type="text"
            name="botName"
            value={config.botName}
            onChange={handleChange}
            placeholder="Your Bot Name"
          />
        </div>
        <div className="form-group">
          <label>Greeting Message</label>
          <textarea
            name="greeting"
            value={config.greeting}
            onChange={handleChange}
            rows="3"
            placeholder="Enter greeting message"
          />
        </div>
        <div className="form-group">
          <label>Tone</label>
          <select name="tone" value={config.tone} onChange={handleChange}>
            <option value="friendly">Friendly</option>
            <option value="formal">Formal</option>
            <option value="professional">Professional</option>
            <option value="casual">Casual</option>
          </select>
        </div>
        <div className="form-group">
          <label>Allowed Topics (Optional)</label>
          <input
            type="text"
            name="allowedTopics"
            value={config.allowedTopics}
            onChange={handleChange}
            placeholder="Comma-separated topics"
          />
          <small>Leave empty to allow all topics</small>
        </div>
        <button onClick={handleSave} className="btn btn-primary">Save Configuration</button>
      </div>
    </div>
  );
};

export default ChatbotConfig;
